import { useState as d, useEffect as m } from "react";
const w = (n, { delay: o = 150, enabled: t = !0 } = {}) => {
  const [e, r] = d(null), i = () => {
    e && clearTimeout(e), r(
      setTimeout(() => {
        const { innerWidth: s, innerHeight: u } = window;
        n({
          width: s,
          height: u
        });
      }, o)
    );
  };
  m(() => (window[t ? "addEventListener" : "removeEventListener"]("resize", i), () => {
    e && clearTimeout(e), window.removeEventListener("resize", i);
  }), [t]);
};
export {
  w as useResize
};
//# sourceMappingURL=useResize.es.js.map
